import { evenRound } from "../../../sharedComponents/common/utils";

export const combineAndRound = (num1: number, num2: number) => evenRound(num1 + num2, 2);
